document.addEventListener("DOMContentLoaded", function () {
  // Retrieve the cookie and populate the BusinessType input field if it exists
  const storedBusinessType = getCookie("CustomerBusinessType");
  const businessTypeInput = document.getElementById(
    "top-search-input-generate"
  );
  if (storedBusinessType) {
    businessTypeInput.value = storedBusinessType;
  }

  const checkButton = document.getElementById("checkButton");
  checkButton.addEventListener("click", function (event) {
    event.preventDefault();
    submitDomainBrandAlignment(this);
  });
});

function submitDomainBrandAlignment(button) {
  const brandNameInput = document.querySelector('input[name="BrandName"]');
  const businessTypeInput = document.getElementById(
    "top-search-input-generate"
  );
  const brandName = brandNameInput.value.trim();
  const businessType = businessTypeInput.value.trim();

  // Set button to loading state

  const BrandMainDiv = document.getElementById("brandAlignmentMainDiv");

  const BrandDiv = document.getElementById("brandAlignmentResponse");

  const LoaderDiv = document.getElementById("brandAlignmentLoader");
  
  const errorMsg = document.getElementById("errorResponse");


  BrandMainDiv.style.display = "none";

  
  errorMsg.innerHTML = "";
  
  LoaderDiv.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" width="200" height="200" style="shape-rendering: auto; display: block; width:50px; height:50px; background: transparent;" xmlns:xlink="http://www.w3.org/1999/xlink"><g><circle cx="50" cy="50" r="0" fill="none" stroke="#e90c59" stroke-width="2"><animate attributeName="r" repeatCount="indefinite" dur="1s" values="0;40" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="0s"></animate><animate attributeName="opacity" repeatCount="indefinite" dur="1s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="0s"></animate></circle><circle cx="50" cy="50" r="0" fill="none" stroke="#4338b4" stroke-width="2"><animate attributeName="r" repeatCount="indefinite" dur="1s" values="0;40" keyTimes="0;1" keySplines="0 0.2 0.8 1" calcMode="spline" begin="-0.5s"></animate><animate attributeName="opacity" repeatCount="indefinite" dur="1s" values="1;0" keyTimes="0;1" keySplines="0.2 0 0.8 1" calcMode="spline" begin="-0.5s"></animate></circle></g></svg>';

  button.innerHTML =
    'Checking <svg width="22" height="22" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="32" stroke-width="8" stroke="#ffffff" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform></circle></svg>';

  if (!brandName || !businessType) {
    LoaderDiv.innerHTML ="";
    displayError("Both BrandName and BusinessType are required.");
    restoreOriginalButton(button);
    return;
  }

  // Set the cookie for BusinessType
  setCookie("CustomerBusinessType", businessType, 7);

  // Send the data to the server
  fetch(
    "https://scripts.brandnic.com/BrandAlignmentAI/BrandPage-GenerateBrandAlignment.php",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: `BrandName=${encodeURIComponent(
        brandName
      )}&BusinessType=${encodeURIComponent(businessType)}`,
    }
  )
    .then((response) => response.json())
    .then((data) => {
      if (data.brandAlignment && data.brandAlignment.success) {
        BrandMainDiv.style.display = "block";
        displaySuccess(data.brandAlignment.msg);
        LoaderDiv.innerHTML ="";

      } else if (data.error) {
        BrandDiv.innerHTML = "";
        LoaderDiv.innerHTML = "";
        BrandMainDiv.style.display = "none";
        displayError(data.error);
      }
      restoreOriginalButton(button);
    })
    .catch((error) => {
      displayError("Failed to fetch response from the server.");
      restoreOriginalButton(button);
    });
}

function restoreOriginalButton(button) {
  button.innerHTML =
    'Check <svg width="22" height="22" viewBox="0 0 20 20" fill="red" xmlns="http://www.w3.org/2000/svg"><path d="M14.1274 1.01957V1.01957C14.4612 3.69008 16.5647 5.79356 19.2352 6.12736V6.12736V6.12736C16.5647 6.46118 14.4612 8.56466 14.1274 11.2352V11.2352V11.2352C13.7936 8.56471 11.6901 6.46117 9.01968 6.12733V6.12733V6.12733C11.6901 5.79355 13.7936 3.69001 14.1274 1.01957V1.01957Z" fill="white"></path><path d="M4.5689 6.01362V6.01362C4.80125 7.87244 6.2654 9.33656 8.12422 9.5689V9.5689V9.5689C6.2654 9.80126 4.80125 11.2654 4.56889 13.1242V13.1242V13.1242C4.33655 11.2654 2.87245 9.80126 1.01368 9.56889H1.01368V9.56889C2.87245 9.33656 4.33655 7.87239 4.5689 6.01362V6.01362Z" fill="white"></path><path d="M9.67949 13.0102V13.0102C9.85394 14.4058 10.9532 15.5051 12.3488 15.6795V15.6795V15.6795C10.9532 15.854 9.85394 16.9533 9.67949 18.3489V18.3489V18.3489C9.50504 16.9533 8.4058 15.854 7.01023 15.6795V15.6795V15.6795C8.4058 15.5051 9.50505 14.4058 9.67949 13.0102V13.0102Z" fill="white"></path></svg>';
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function displaySuccess(message) {
  const responseDiv = document.getElementById("brandAlignmentResponse");
  responseDiv.innerHTML = message;
}

function displayError(message) {
  const errorDiv = document.getElementById("errorResponse");
  errorDiv.textContent = message;
}
